import { z } from 'zod';

export const AcceptTermsStatusResultSchema = z.object({
  data: z.object({
    terms_and_conditions_accepted: z.boolean(),
    terms_and_conditions_version: z.string(),
    terms_and_conditions_updated_at: z.number(),
  }),
});

export type AcceptTermsStatusResult = z.infer<
  typeof AcceptTermsStatusResultSchema
>;

export interface AcceptTermsStatusParams {
  currency: string;
}
